import styled from "styled-components";

export const Section = styled.section `
    margin: 2rem;
`